import { render, staticRenderFns } from "./KycStatusApproved.vue?vue&type=template&id=5a182ca2&scoped=true&"
import script from "./KycStatusApproved.vue?vue&type=script&lang=js&"
export * from "./KycStatusApproved.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a182ca2",
  null
  
)

export default component.exports